module.exports = __webpack_public_path__ + "img/2022-12-02_13-19-27.63d875a2.jpg";